import type { SxProps, Theme } from "@mui/material";

/** Brand gradient header for MUI dialogs — no decorative corner shade. */
export const dialogBrandHeaderSx: SxProps<Theme> = {
	background: "linear-gradient(135deg, #026CB5 0%, #025c9a 100%)",
	color: "white",
	pb: 2,
};

/** White circular close control — employer portal style (on brand header). */
export const dialogHeaderCloseIconButtonSx: SxProps<Theme> = {
	bgcolor: "white",
	color: "#161616",
	width: 36,
	height: 36,
	flexShrink: 0,
	"&:hover": {
		bgcolor: "rgba(255,255,255,0.92)",
	},
};

/** Close control on white modal headers (shared Modal, custom headers). */
export const modalCloseButtonClassName =
	"inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-ink shadow-sm transition-colors hover:bg-gray-50";
